/** @format */

import ApiService from '@/common/api.services';
import localStorageServices from '@/common/jwt.services';
import sessionStorgeServices from '@/common/storage.services';

import {
  FETCH_EVENT_CATEGORIES,
  FETCH_EVENTS,
  FETCH_CAT_EVENTS,
  FETCH_TICKETS,
  FETCH_EVENT,
  FETCH_EVENT_BY_DATE,
  FETCH_EVENT_VIDEO,
  // FETCH_TAGS,
  VALIDATE_TICKET,
  REMOVE_HOLD_TICKET,
  TICKET_HOLD_SESSION,
  BUY_TICKET,
  MY_EVENTS,
  MY_REWARD_POINTS,
  MY_REWARD_SUMMARY ,
  VERIFY_QR,
  FETCH_PROMOTER,
  PRINT_TICKET,
  MYT_MONEY,
  CREATE_MCB_SESSION,
  PAYMENT_COMPLETE,
  PAYMENT_CANCEL,
  RESET_EVENT,
  VALIDATE_EVENT_CODE,
  VALIDATE_EGIFT_VOUCHER,
  VALIDATE_SEATS,
  UPDATE_BOOKING_SEATS,
  RELEASE_BOOKING_SEAT,
  SET_EGIFT_VOUCHER,
  SET_TICKET_VALIDATION_ON_PAGE_REFRESH,
  SAVE_EVENT_API_BODY,
  SET_EVENT_API_BODY,
  GET_LOCAL_STORAGE,
  SET_PROMOTER,
  LEAST_TICKET_PRICE,
  CREATE_SPARK_TOKEN,
  VALIDATE_EVENT_GLOBAL_PROMOCODE
} from './actions.type';

import {
  SET_EVENT_CATEGORIES,
  SET_EVENTS,
  SET_CAT_EVENTS,
  SET_PROMOTIONAL_EVENTS,
  SET_TICKETS,
  SET_EVENT,
  SET_VIDEOS,
  SET_TICKET_HOLD_SESSION,
  SET_TICKET_VALIDATION,
  SET_MY_EVENTS,
  // SET_TAGS,
  SET_EMPTY_EVENT
} from './mutations.type';

const state = {
  cachedTime: null,
  categories: [],
  events: {},
  catEvents: [],
  promotionalEvents: [],
  eventsCount: 0,
  isLoading: true,
  tickets: [],
  ticketValidation: null,
  singleEvent: null,
  isTicketValidation: false,
  eventVideo: [],
  myEvents: [],
  myEventsCount: 0,
  // eventTags: '',
  verifyQR: '',
  apiBody: '',
  leastTicketPrice: null,
  isFreeTicket: false,
  promoter: {},
  voucherPayment: { message: "", discount: null , voucherId:"", voucherAmount:null },

};

const getters = {
  cachedTime() {
    return state.cachedTime
  },
  getTicketsByEvent: state => eventId => {
    const tickets = state.tickets.filter(({ eventId: id }) => id === eventId);
    if (tickets.length)
      return tickets[0].tickets.filter(
        ({ endDate }) => new Date(endDate).getTime() > new Date().getTime()
      );
  },

  getEventByCategory: state => catId =>
    state.categories.find(({ _id }) => _id === catId),

  eventCategories(state) {
    return state.categories;
  },
  events(state) {
    return state.events;
  },
  catEvents(state) {
    return state.catEvents;
  },
  promotionalEvents(state) {
    return state.promotionalEvents;
  },
  eventsCount(state) {
    return state.eventsCount;
  },
  isLoading(state) {
    return state.isLoading;
  },
  singleEvent(state) {
    return state.singleEvent;
  },
  tickets(state) {
    return state.tickets[0];
  },
  isTicketValidation(state) {
    return state.isTicketValidation;
  },
  eventVideo(state) {
    return state.eventVideo;
  },
 
  // eventTags(state) {
  //   return state.eventTags;
  // },
  myBookings(state) {
    return state.myEvents;
  },
  myEvents(state) {
    return state.myEvents.filter(({ ticketId }) => ticketId);
  },
  myRooms(state) {
    return state.myEvents.filter(({ roomId }) => roomId);
  },
  myEventsCount(state) {
    return state.myEventsCount;
  },
  verifyQR(state) {
    return state.verifyQR;
  }
};

const actions = {
  [SAVE_EVENT_API_BODY]({ commit }, apiBody) {
    commit(SET_EVENT_API_BODY, apiBody);
  },
  [GET_LOCAL_STORAGE]({ commit }) {
//     commit(
//       SET_TICKET_VALIDATION_ON_PAGE_REFRESH,
// JSON.parse(localStorageServices.getObject('ticketValidation'))
//     );
    commit(
      SET_TICKET_VALIDATION_ON_PAGE_REFRESH,
      JSON.parse(sessionStorage.getItem('ticketValidation'))
    );
  },

  [FETCH_EVENT_CATEGORIES](context) {
    return ApiService.getWithParams('categories', { params: { skip: 0, limit: 999 } })
      .then(response => {
        context.commit(SET_EVENT_CATEGORIES, response.data.response.data);
        return response.data.response.data;
      })
      .catch(response => {
        context.commit(SET_EVENT_CATEGORIES, response.data.message);
      });
  },
  [FETCH_EVENTS](state, params) {
    state.isLoading = true;
    return ApiService.getWithParams('search/events', {
      params
    })
      .then(({ data }) => {
        state.commit(SET_EVENTS, { ...data.response, params });
        return data.response.data;
      })
      .catch(error => {
        return error.response;
      });
  },
  [FETCH_CAT_EVENTS](state, params) {
    return ApiService.getWithParams('search/events', {
      params
    })
      .then(({ data }) => {
        state.commit(SET_CAT_EVENTS, data.response);
        return data.response;
      })
      .catch(error => {
        return error.response;
      });
  },

  [FETCH_EVENT_VIDEO](context, eventData) {
    return ApiService.get('getAllVideos', eventData)
      .then(({ data }) => {
        context.commit(SET_VIDEOS, data.data.eventFiles);
        return data.data.eventFiles;
      })
      .catch(error => {
        return error.response.status;
      });
  },
  // [FETCH_TAGS](context, tagId) {
  //   return ApiService.get('getAllTags')
  //     .then(({ data }) => {
  //       context.commit(SET_TAGS, data.data);
  //       return data.data;
  //     })
  //     .catch(error => {
  //       return error.response.status;
  //     });
  // },
  [FETCH_EVENT](context, articleSlug, prevArticle) {
    if (prevArticle !== undefined) {
      return context.commit(SET_EVENT, prevArticle);
    }

    return ApiService.get('event', articleSlug)
      .then(({ data }) => {
        context.commit(SET_EVENT, data.response.data);
        return data.response;
      })
      .catch(error => {
        return error.response && error.response.status;
      });
  },
  [FETCH_EVENT_BY_DATE](context, url) {
  
    return ApiService.get(url)
      .then(({ data }) => {
        // context.commit(SET_EVENT, data.response.data);
        return data.response;
      })
      .catch(error => {
        return error.response && error.response.status;
      });
  },
  [RESET_EVENT](context) {
    context.commit(SET_EMPTY_EVENT, {});
  },
  [FETCH_PROMOTER]({ commit }, promoterId) {
    return ApiService.get('promoter', promoterId).then(({ data }) => {
      commit(SET_PROMOTER, data.data);
      return data.data;
    });
  },

  [FETCH_TICKETS](context, eventData) {
    return ApiService.get('getTickets', eventData).then(({ data }) => {
      context.commit(SET_TICKETS, data.data);
      return data.data;
    });
  },
  [VALIDATE_TICKET](context, params) {
    return ApiService.post('validateTicket', params)
      .then(({ status, data }) => {
        if (status === 200) {
          context.commit(SET_TICKET_VALIDATION, { ticket: {...data.data, isSeatedEvent: state.singleEvent.isSeatedEvent, seatIOKey: state.singleEvent.seatIOKey}, type: 'new' });
          return data;
        }
      })
      .catch(error => {
        let localResponse = {
          error: error.response.data.error,
          status: error.response.status,
          message: error.response.data.message
        };
        return localResponse;
      });
  },
 
  [VALIDATE_EVENT_GLOBAL_PROMOCODE]({ commit }, params) {
      state.isLoading = true;
      return ApiService.post("/apply-global-promocode", params)
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          console.log("error",error)
          state.isLoading = false;
          return error.response.status;
        });
    },
  [VALIDATE_SEATS](context, params) {
    return ApiService.post('checkSeat', params)
      .then(response => {  
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error("error", error);
        return { success: false, error: error.response.data };
      });
  },
  [UPDATE_BOOKING_SEATS](context, { bookingId, seats, seatHoldToken, status }) {
    if (!bookingId) {
      return Promise.resolve(null);
    }

    const body = {
      status,
      seats,
      seatHoldToken,
    };

    return ApiService.put(`/bookings/${bookingId}`, body)
      .then((response) => response.data)
      .catch((error) => {
        console.error("error", error);
        return error.response || error;
      });
  },
  [RELEASE_BOOKING_SEAT](context, { bookingId, holdToken }) {
    if (!bookingId || !holdToken) {
      return Promise.resolve(null);
    }

    return ApiService.post('bookings/release-seat', {
      bookingId,
      holdToken,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.error("error", error);
        return error.response || error;
      });
  },
  [VALIDATE_EGIFT_VOUCHER](context, params) {
  return ApiService.post('voucher/validate', params)
    .then(response => {
      context.commit(SET_EGIFT_VOUCHER, response.data.response);

      return { success: true, data: response.data };
    })
    .catch(error => {
      console.error("error", error);
      return { success: false, error: error.response.data };
    });
},

  [TICKET_HOLD_SESSION](context, params) {
    return ApiService.post('getTicketHoldSessionTTL', params)
      .then(response => {
        context.commit(SET_TICKET_HOLD_SESSION, response.data.data);

        if (response.data.data) {
          if (!response.data.data.timeRemaining)
            context.dispatch(REMOVE_HOLD_TICKET);
        }
        return response.data.data;
      })
      .catch(error => { });
  },
  [REMOVE_HOLD_TICKET](context, params) {
    return ApiService.put('releaseTicket', params)
      .then(response => {
        context.commit(REMOVE_HOLD_TICKET);
      })
      .catch(error => {
        return error.response.status;
      });
  },
  [BUY_TICKET](context, params) {
    return ApiService.post('buyTicket', params)
      .then(response => {
        return response.data.response.data;
            })
      .catch(error => {
        return error.response.status;
      });
  },
  [CREATE_SPARK_TOKEN](context, params) {
    return ApiService.post('spark/token/create', params)
      .then(response => {
        return response.data.response;
      })
      .catch(error => {
        return error.response.status;
      });
  },
  [MYT_MONEY](context, params) {
    ApiService.setHeader();
    return ApiService.post('payments/mytmoney/initiate', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response.status;
      });
  },
  [CREATE_MCB_SESSION](context, params) {
    return ApiService.post('/payments/mcbcards/initiate', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  [PAYMENT_COMPLETE](context, params) {
    ApiService.setHeader();

    return ApiService.post(`payment/complete/${params.billingId}`, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  [PAYMENT_CANCEL](context, params) {
    ApiService.setHeader();

    return ApiService.put('updateOrderStatus', params)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [VERIFY_QR](context, params) {
    return ApiService.post('verifyUser', params)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        return error.response.status;
      });
  },
  [MY_EVENTS](context, params) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (!!userStored) {
      ApiService.setHeader();
      context.state.isLoading = true;
      return ApiService.getWithParams('booking/purchased', {
        params
      })
        .then(({ data: { response } }) => {
          context.state.isLoading = false;
          context.commit(SET_MY_EVENTS, response);
          return response.data;
        })
        .catch(error => {
          context.state.isLoading = false;
          return error.response;
        });
    }
  },
  [MY_REWARD_POINTS](context, params) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (!!userStored) {
      ApiService.setHeader();
      return ApiService.getWithQueryParams('rewards', params)
        .then(({ data }) => {
          // Assuming the API response structure matches this:
          return data.response;
        })
        .catch(error => {
          console.error('Error in fetching rewards:', error);
          return Promise.reject(error);
        });
    } else {
      // Handle case when no user is stored
      console.error('No user stored');
      return Promise.reject('No user stored');
    }
  },
  [MY_REWARD_SUMMARY](context, params) {
    let userStored = JSON.parse(localStorageServices.getObject('Auth'));
    if (!!userStored) {
      ApiService.setHeader();
      return ApiService.get('rewards/summary')
        .then(({ data }) => {
          return data.response;
        })
        .catch(error => {
          console.error('Error in fetching rewards:', error);
          return Promise.reject(error);
        });
    } else {
      // Handle case when no user is stored
      console.error('No user stored');
      return Promise.reject('No user stored');
    }
  },
  [PRINT_TICKET](context, params) {
    return ApiService.get('getPrintableTicket/' + params)
      .then(({ data }) => {
        return data.data;
      })
      .catch(error => {
        console.log(error);
        return error.response;
      });
  }
};

const mutations = {
  [SET_EVENT_API_BODY](state, apiBody) {
    state.apiBody = apiBody;
  },
  [SET_EVENT_CATEGORIES](state, response) {
    state.categories = response;
  },
  [SET_EVENTS](state, response) {
    const { cat, isPromotional } = response.params;
    if (cat) {
      isPromotional
        ? (state.events[response.params.cat] = response.data)
        : (state.events = { [response.params.cat]: response.data });
    } else {
      state.events = { eventList: response.data };
    }
    state.eventsCount = response.count ? response.count : response.data.length;
    state.isLoading = false;
  },
  [SET_MY_EVENTS](state, response) {
    state.myEvents = response.data;
    state.myEventsCount = response.count;
    state.isLoading = false;
  },
  [SET_CAT_EVENTS](state, response) {
    response.data.forEach((event, key) => {
      if (event.isRecommended) {
        let eventIndex = _.findIndex(state.catEvents, ['_id', event._id]);
        if (eventIndex == -1) {
          state.catEvents.push(event);
        }
      }
    });
  },
  [SET_PROMOTIONAL_EVENTS](state, response) {
    state.promotionalEvents = response.data;
  },
  [SET_TICKETS](state, tickets) {
    if (tickets) {
      let ticketIndex = _.findIndex(state.tickets, [
        'eventId',
        tickets.eventId
      ]);
      if (ticketIndex === -1) {
        state.tickets.push(tickets);
      }
    }
  },
  [SET_EVENT](state, data) {
    state.singleEvent = data;
  },
  [SET_PROMOTER](state, data) {
    state.promoter = data;
  },
  [LEAST_TICKET_PRICE](state, data) {
    state.leastTicketPrice = data.price;
    state.isFreeTicket = data.isFree;
  },
  [SET_EMPTY_EVENT](state, data) {
    state.singleEvent = data;
  },
  [SET_VIDEOS](state, data) {
    state.eventVideo = data;
  },
 
  [SET_EGIFT_VOUCHER](state, res) {
    if (res) {
      
      
      state.voucherPayment.discount = res.data.balance;
      state.voucherPayment.voucherId = res.data._id
      state.voucherPayment.voucherAmount = res.data.balance
      state.voucherPayment.message = null;
    }
 
    state.isLoading = false;
  },
  // [SET_TAGS](state, data) {
  //   state.eventTags = data;
  // },
  [SET_TICKET_VALIDATION](state, response) {
    if (response && response.type === 'new') {
      state.ticketValidation = response.ticket;
      const tabId = Math.random().toString(36).slice(2, 15);
    const ticketObject = { ...response.ticket, tabId };
    state.ticketValidation = ticketObject;
    // localStorageServices.setObject('ticketValidation', ticketObject);
    sessionStorage.setItem('ticketValidation', JSON.stringify(response.ticket));

    } else if (response && response.type === 'update') {
      state.ticketValidation = sessionStorgeServices.updateItem(response.ticket[0], response.ticket[1], response.ticket[2]);
    }
    state.isTicketValidation = true;
  },
  [SET_TICKET_VALIDATION_ON_PAGE_REFRESH](state, data) {
    state.ticketValidation = data;
  },
  [SET_TICKET_HOLD_SESSION](state, response) {
    state.cachedTime = response.timeRemaining
  },
  [REMOVE_HOLD_TICKET](state) {
    state.cachedTime = null;
    state.isTicketValidation = false;
    // localStorageServices.destroyObject('ticketValidation');
    sessionStorage.removeItem('ticketValidation');

    localStorageServices.destroyObject('seatHoldToken');
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
